module.exports = __webpack_public_path__ + "img/contato.81a9785a.png";